import { render, staticRenderFns } from "./ModalProcessTabGeneral.vue?vue&type=template&id=4073622c&scoped=true"
import script from "./ModalProcessTabGeneral.vue?vue&type=script&lang=js"
export * from "./ModalProcessTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessTabGeneral.vue?vue&type=style&index=0&id=4073622c&prod&scoped=true&lang=css"
import style1 from "./ModalProcessTabGeneral.vue?vue&type=style&index=1&id=4073622c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073622c",
  null
  
)

export default component.exports